/**
 * Data efetiva do desligamento no distrato (#6135).
 *
 * O fluxo n8n "05. [FINANCEIRO] Distrato" somava 30 dias fixos à data da
 * solicitação, mas o contrato (Quadro Resumo) dá 90 dias de aviso prévio — o
 * cliente ouvia "até 90 dias" e o documento dizia 30. O prazo vem de
 * `system_settings.cancelamento_aviso_previo_dias`, o mesmo que a validação do
 * cancelamento já usa. Dias corridos.
 *
 * Datas em 'AAAA-MM-DD' e conta em UTC: `new Date('2026-08-31')` é meia-noite UTC,
 * e somar com getDate/setDate no fuso de Brasília volta um dia.
 */

export const AVISO_PREVIO_DIAS_PADRAO = 90;

const ISO = /^(\d{4})-(\d{2})-(\d{2})$/;

/** Prazo lido da configuração; inválido, vazio ou negativo cai no padrão do contrato. */
export function avisoPrevioDias(valor: unknown): number {
    const n = Number(String(valor ?? '').trim());
    return Number.isInteger(n) && n > 0 ? n : AVISO_PREVIO_DIAS_PADRAO;
}

/** Data da solicitação + dias. '' quando a data não é válida. */
export function calcularDataEfetiva(dataSolicitacao: string, dias: number): string {
    const m = ISO.exec(String(dataSolicitacao ?? '').trim());
    if (!m) return '';
    const d = new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3])));
    if (d.getUTCMonth() !== Number(m[2]) - 1) return ''; // 2026-02-31 e afins
    d.setUTCDate(d.getUTCDate() + dias);
    return d.toISOString().slice(0, 10);
}

/** Motivo para barrar a emissão, ou null. */
export function problemaDataEfetiva(dataSolicitacao: string, dataEfetiva: string): string | null {
    if (!ISO.test(dataEfetiva || '')) return 'Informe a data efetiva do desligamento.';
    if (ISO.test(dataSolicitacao || '') && dataEfetiva < dataSolicitacao) {
        return 'A data efetiva do desligamento não pode ser anterior à data da solicitação.';
    }
    return null;
}
